
/**
 * @typedef Label
 * @type {Object}
 * 
 * Order no
 * @property {String} orderNo
 * 
 * User
 * @property {String} userId
 * @property {String} name
 * @property {String} gender
 * @property {String} mobile
 * @property {String} birthYear
 * @property {String} taxId
 * 
 * Subscription
 * @property {String} projectName
 * @property {String} address
 * @property {String} category
 * @property {String} packageId
 * @property {String} packageName
 * @property {String} seller
 * @property {String} type
 * @property {String} txnStatus
 * @property {String} billingStatus
 * @property {String} actualStatus
 *
 * Service
 * @property {String} serviceName
 * @property {String} serviceProviderName
 * @property {String} serviceCostBeforeVat
 * @property {String} serviceCostAfterVat
 *
 * Appointment
 * @property {String} bookedAt
 * @property {String} performedAt
 * @property {String} performedTime
 * @property {String} confirmedAt
 * @property {String} usedAt
 * @property {String} closedAt
 * @property {String} appointmentProviderName
 * @property {String} actualCost
 * @property {String} maintNo
 * @property {String} hasRemark
 *
 * Pricing
 * @property {String} paymentDate
 * @property {String} paymentTime
 * @property {String} dateStart
 * @property {String} dateEnd
 * @property {String} optMain
 * @property {String} optExtra
 * @property {String} optMainPrice
 * @property {String} optExtraPrice
 * @property {String} quantity
 * @property {String} sellingPriceAfterVat
 * @property {String} discount
 * @property {String} netSellingPriceAfterVat
 * @property {String} vat
 * @property {String} sellingPriceBeforeVat
 * @property {String} netIncomeBeforeMdr
 * @property {String} mdrAndVat
 * @property {String} feeRateText
 * @property {String} netFee
 * @property {String} netIncome
 *
 * Receipt
 * @property {String} creditNoteNo
 * @property {String} paymentChannel
 * @property {String} receiptInfo
 * @property {String} receiptNo
 * @property {String} refCode
 * @property {String} note
 * 
 * SAP
 * @property {String} sapProviderName
 * @property {String} sapServiceType
 * @property {String} vendorReceiptDate
 * @property {String} vendorReceiptNo
 * @property {String} purchaseOrder
 * @property {String} sapPrice
 * 
 * MNC
 * @property {String} coinAmount
 * @property {String} coinValue
 * @property {String} coinWallet
 */

/**
 * @typedef Group
 * @type {Object}
 * @property {String} fixed
 * @property {String} user
 * @property {String} subscription
 * @property {String} pricing
 * @property {String} service
 * @property {String} appointment
 * @property {String} receipt
 * @property {String} sap
 * @property {String} mnc
 */

export class SubsReportFieldCommon {

  /** @type {Label} Field keys in column order */
  static labels = [

    // order
    'userId',

    // user
    'name',
    'gender',
    'mobile',
    'birthYear',
    'taxId',

    // subscription
    'orderNo',
    'packageId',
    'packageName',
    'projectName',
    'address',
    'category',
    'seller',
    'type',
    'txnStatus',
    'billingStatus',
    'actualStatus',

    // service
    'serviceName',
    'serviceProviderName',
    'serviceCostBeforeVat',
    'serviceCostAfterVat',

    // appointment
    'bookedAt',
    'performedAt',
    'performedTime',
    'confirmedAt',
    'usedAt',
    'closedAt',
    'appointmentProviderName',
    'actualCost',
    'maintNo',
    'hasRemark',

    // pricing
    'paymentDate',
    'paymentTime',
    'dateStart',
    'dateEnd',
    'optMain',
    'optExtra',
    'optMainPrice',
    'optExtraPrice',
    'quantity',
    'sellingPriceAfterVat',
    'discount',
    'netSellingPriceAfterVat',
    'vat',
    'sellingPriceBeforeVat',
    'netIncomeBeforeMdr',
    'mdrAndVat',
    'feeRateText',
    'netFee',
    'netIncome',

    // receipt
    'creditNoteNo',
    'paymentChannel',
    'receiptInfo',
    'receiptNo',
    'refCode',
    'note',

    // sap
    'sapProviderName',
    'sapServiceType',
    'sapPrice',
    'purchaseOrder',
    'vendorReceiptNo',
    'vendorReceiptDate',

    // mnc
    'coinWallet',
    'coinAmount',
    'coinValue',
  ].reduce(
    (prev, key) => ({...prev, [key]: key }), {}
  )

  /** @type {Group} Group keys */
  static groups = [
    'fixed',
    'user',
    'subscription',
    'service',
    'appointment',
    'pricing',
    'receipt',
    'sap',
    'mnc',
  ].reduce(
    (prev, key) => ({...prev, [key]: key }), {}
  )
}
